import { List } from "antd";
import { useState, useEffect } from "react";

function LatestPayments({ latestPayments }) {
  const [paymentData, setPaymentData] = useState();

  useEffect(() => {
    setPaymentData(latestPayments);
  }, [latestPayments]);

  return (
    <List
      itemLayout="horizontal"
      dataSource={paymentData}
      renderItem={(item) => (
        <List.Item>
          <List.Item.Meta
            title={item.customer}
            description={`${item.amount}€ - ${item.created}`}
          />
        </List.Item>
      )}
    />
  );
}

export default LatestPayments;
